import { setGlobalTheme, ThemeColorModes } from '@atlaskit/tokens';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import * as store from 'src/components/navigation/src/navigation-store';
import { useStatsigGate } from 'src/contexts/feature-provider';

let initialPageLoad = true;
const isInitialPageLoad = () => initialPageLoad;
export const setIsInitialPageLoad = (isInitial: boolean) => {
  initialPageLoad = isInitial;
};

export const RenderTheme = ({
  initialGlobalTheme,
}: {
  initialGlobalTheme?: string | null;
}) => {
  const globalTheme =
    (isInitialPageLoad()
      ? (initialGlobalTheme as ThemeColorModes)
      : store.getColorTheme()) || 'light';
  const isRefreshTypographyEnabled = useStatsigGate(
    StatsigFeatureKeys.bbcRefreshedTypography
  );
  setGlobalTheme({
    colorMode: globalTheme,
    typography: isRefreshTypographyEnabled ? 'typography-refreshed' : undefined,
  });

  if (isInitialPageLoad()) {
    // Set theme in localStorage on initial page load
    store.setColorTheme(globalTheme);
  }
  setIsInitialPageLoad(false);

  return null;
};
